export default __webpack_public_path__ + "static/media/NotoSans-Italic.6433373a.otf";